import moment from "moment"
import * as urls from "./urls"
import { get, post } from "services/api"

const getOrders = (filters, offset, limit = 20, page = 1) => {
  const allFilters = {
    ...filters,
    startAt: filters.startAt
      ? moment(filters.startAt).format("YYYY-MM-DD")
      : null,
    endAt: filters.endAt ? moment(filters.endAt).format("YYYY-MM-DD") : null,
    onTime: filters?.onTime?.value,
    clientName: filters?.clientName ? filters?.clientName.trim() : "",
  }
  return get(urls.GET_FILTER_RASTREIO, {
    params: {
      ...allFilters,
      offset,
      limit,
    },
  })
}

const getOrderOptions = () => {
  return get(urls.GET_OPTIONS)
}

const getGestao = (filters, page, limit) => {
  const allFilters = {
    ...filters,
    startAt: filters.startAt
      ? moment(filters.startAt).format("YYYY-MM-DD")
      : null,
    endAt: filters.endAt ? moment(filters.endAt).format("YYYY-MM-DD") : null,
  }
  return get(urls.GET_GESTAO, {
    params: {
      ...allFilters,
      page: page,
      limit,
    },
  })
}

const getCheckboxes = () => {
  return get(urls.GET_REPORT_CHECKBOXES)
}

const postOrders = async (formData, query, offset, limit = 20) => {
  const allFilters = {
    ...query,
    startAt: query.startAt ? moment(query.startAt).format("YYYY-MM-DD") : null,
    endAt: query.endAt ? moment(query.endAt).format("YYYY-MM-DD") : null,
    onTime: query?.onTime?.value,
  }
  return post(urls.POST_FILTER_RASTREIO, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    params: { ...allFilters, offset, limit },
  })
}

const postReportFile = (
  filters,
  formData,
  addToQueue,
  userId,
  fileType,
  baseType,
  checkboxes
) => {
  const allFilters = {
    ...filters,
    startAt: moment(filters.startAt).format("YYYY-MM-DD"),
    endAt: moment(filters.endAt).format("YYYY-MM-DD"),
    onTime: filters?.onTime?.value,
  }

  formData["addToQueue"] = addToQueue
  formData["userId"] = userId
  formData["filters"] = JSON.stringify(allFilters)
  formData["fileType"] = fileType
  formData["baseType"] = baseType
  formData["checkboxes"] = JSON.stringify(checkboxes)

  return post(urls.POST_REPORT_FILE, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
}

const postReport = (
  filters,
  addToQueue,
  userId,
  fileType,
  baseType,
  checkboxes
) => {
  const allFilters = {
    ...filters,
    startAt: moment(filters.startAt).format("YYYY-MM-DD"),
    endAt: moment(filters.endAt).format("YYYY-MM-DD"),
    onTime: filters?.onTime?.value,
  }
  return post(urls.POST_REPORT, {
    filters: allFilters,
    userId,
    addToQueue,
    fileType,
    baseType,
    checkboxes: JSON.stringify(checkboxes),
  })
}

const postHistoryReport = (courier, dates, status, userId) => {
  const allFilters = {
    courierId: courier,
    startAt: moment(dates.startAt).format("YYYY-MM-DD"),
    endAt: moment(dates.endAt).format("YYYY-MM-DD"),
    status: status ? status : [],
  }
  return post(urls.POST_REPORT_HISTORY, {
    filters: allFilters,
    userId,
  })
}

export {
  // GETS
  getOrders,
  getOrderOptions,
  getGestao,
  getCheckboxes,
  // POSTS
  postOrders,
  postReportFile,
  postReport,
  postHistoryReport,
}
